import {
  CheckoutHostedPaymentMethodPageHitV2,
  SelectPaymentMethodCheckoutHostedPaymentMethodClickV1,
} from '@inditex/resellanl-ianalytics-events';
import { buildEvent } from '../helpers/build-event';
import { normalizeUniverse } from '../helpers/normalize-universe';

export const CHECKOUT_HOSTED_PAYMENT_METHOD_PAGE_HIT = ({ data }: { data?: unknown }) => {
  const payload = data as {
    cartId?: string | number | null;
    isEmbedded?: boolean | null;
    universe?: string | null;
    travelMode?: boolean | null;
    storeMode?: unknown;
  };

  return buildEvent({
    Event: CheckoutHostedPaymentMethodPageHitV2,
    payload: {
      cartId: payload?.cartId != null ? String(payload.cartId) : '',
      isEmbedded: payload?.isEmbedded ?? false,
      universe: payload?.universe ? normalizeUniverse(payload.universe) : null,
      travelMode: payload?.travelMode ?? null,
      storeMode: payload?.storeMode ?? null,
    },
  });
};

export const SELECT_PAYMENT_METHOD_CHECKOUT_HOSTED_PAYMENT_METHOD_CLICK = ({ data }: { data?: unknown }) => {
  const payload = data as {
    paymentMethod?: string | null;
    universe?: string | null;
    travelMode?: boolean | null;
    storeMode?: unknown;
  };

  return buildEvent({
    Event: SelectPaymentMethodCheckoutHostedPaymentMethodClickV1,
    payload: {
      paymentMethod: payload?.paymentMethod ?? '',
      universe: payload?.universe ? normalizeUniverse(payload.universe) : null,
      travelMode: payload?.travelMode ?? null,
      storeMode: payload?.storeMode ?? null,
    },
  });
};
